// src/hooks/useMediaQuery.js
import { useState, useEffect } from 'react';

/**
 * Кастомный хук для отслеживания медиа-запросов (например, ширины экрана).
 * @param {string} query - Строка медиа-запроса, например, '(max-width: 768px)'.
 * @returns {boolean} - true, если медиа-запрос соответствует, иначе false.
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    // Обновляем состояние, если медиа-запрос меняется (например, при повороте экрана)
    const listener = () => {
      setMatches(media.matches);
    };
    
    // Вызываем один раз при монтировании, чтобы установить начальное значение
    listener();
    
    // Подписываемся на изменения
    media.addEventListener('change', listener);

    // Отписываемся при размонтировании
    return () => media.removeEventListener('change', listener);
  }, [query]); // Зависимость от строки запроса

  return matches;
}